
import React from 'react';
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useNavigate } from 'react-router-dom';

interface ProfileHeaderProps {
  title: string;
  description: string;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ title, description }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-start gap-6">
      <div className="flex w-full items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
          <p className="text-muted-foreground">
            {description}
          </p>
        </div>
        <Button variant="outline" onClick={() => navigate('/')}>
          Vissza a főoldalra
        </Button>
      </div>

      <Separator className="my-6" />
    </div>
  );
};

export default ProfileHeader;
